import { IGachaAccountStateResponse } from '~/types/gacha';
import { IInitGachaBanners, IUpdateAccountState, IUpdateAnimationState, IUpdateTransactions } from './ActionGachaBannerType';
import { MercatorMysteryContentState } from '~/types/mercator';

export const INIT_GACHA_BANNERS = 'INIT_GACHA_BANNERS';
export const initGachaBanners = (payload: MercatorMysteryContentState): IInitGachaBanners => {
    return {
        type: INIT_GACHA_BANNERS,
        payload,
    };
};

export const UPDATE_ACCOUNT_STATE = 'UPDATE_ACCOUNT_STATE';
export const updateAccountState = (payload: IGachaAccountStateResponse): IUpdateAccountState => {
    return {
        type: UPDATE_ACCOUNT_STATE,
        payload,
    };
};

export const UPDATE_TRANSACTION = 'UPDATE_TRANSACTION';
export const updateTransactions = (bundleName: string, transactionId: Nullable<string>): IUpdateTransactions => {
    return {
        type: UPDATE_TRANSACTION,
        bundleName,
        transactionId,
    };
};

export const UPDATE_ANIMATION_STATE = 'UPDATE_ANIMATION_STATE';
export const updateAnimationState = (isStarted: boolean = false): IUpdateAnimationState => {
    return {
        type: UPDATE_ANIMATION_STATE,
        isStarted,
    };
};
